module.exports = __webpack_public_path__ + "static/media/end-call.e5098b61.svg";